import React, { useEffect } from "react";
import $ from "jquery";
import State from "../data/state";
// Import Highcharts
import Highcharts from "highcharts/highmaps";
import drilldown from "highcharts/modules/drilldown";
import dataModule from "highcharts/modules/data";

// import mapData from "../data/mapData";
import IndiaMapData from "../data/IndiaMapData";
// import punjab from '../data/punjab'

import HighchartsReact from "highcharts-react-official";
import AllState from "../data/FinancialData/AllState";
import { faker } from "@faker-js/faker";
import axios from "axios";

drilldown(Highcharts); //imported drilldown module
dataModule(Highcharts); //imported data module

//Highcharts.maps['myMapName'] = mapData
// Load Highcharts modules
require("highcharts/modules/exporting")(Highcharts);

//this data variable will be passed in hicharts ooptions props
var data = Highcharts.geojson(Highcharts.maps["countries/us/us-all"]),
  separators = Highcharts.geojson(
    Highcharts.maps["countries/us/us-all"],
    "mapline"
  );
//function to find data from json
// function getCountryByCode(code) {
//   return AllState.filter(
//       function(data){ return data.code == code }
//   );
// }

// Set drilldown pointers
data.forEach((el, i) => {
  // const matched = SData.filter((e) => e.HCA2 === el.properties["hc-a2"]);
  // let totalAmmount = 0;
  // if (matched.length > 0) {
  //   matched.forEach((element) => {
  //     totalAmmount += element.Total_Transaction;
  //   });
  // }
  // console.log(`totalAmount of   ${el.properties["hc-a2"]} is ${totalAmmount}`);

  el.drilldown = el.properties["hc-a2"];
  el.value = Math.floor((Math.random()*1000000)+1);
})

window.Highcharts = Highcharts;

const options = {
  chart: {
    buttons: {
      contextButton: {
        menuItems: ["printChart", "separator", "downloadPNG", "downloadPDF"],
      },
    },
    backgroundColor: "#F9F8FA",
    events: {
      drilldown: function (e) {
        if (!e.seriesOptions) {
          console.log(e.point.name);
          var chart = this,
            mapKey = `${e.point.drilldown}`,
            fail = setTimeout(function () {
              if (!Highcharts.maps[mapKey]) {
                chart.showLoading("Failed loading " + e.point.name);
                fail = setTimeout(function () {
                  chart.hideLoading();
                }, 1000);
              }
            }, 30000);

          // Show the spinner
          chart.showLoading("<p>Loading...</p>"); // Font Awesome spinner

          // Load the drilldown map
          $.getScript(
            State[mapKey], //file path apna local hoga
            function () {
              data = Highcharts.geojson(Highcharts.maps[mapKey]);

              // Set a non-random bogus value
              $.each(data, function (i) {
                this.value = i;
              });

              // Hide loading and add series
              chart.hideLoading();
              clearTimeout(fail);
              chart.addSeriesAsDrilldown(e.point, {
                name: e.point.name,
                data: data,
                dataLabels: {
                  enabled: true,
                  format: "{point.name}",
                },
              });
            }
          );
        }

        this.setTitle(null, { text: e.point.name });
      },
      drillup: function () {
        this.setTitle(null, { text: "" });
      },
    },
  },

  legend: {
    layout: "vertical",
    align: "right",
    verticalAlign: "middle",
  },

  colorAxis: {
    min: 0,
    minColor: "#EBE9FD",
    maxColor: "#5350f6",
  },

  mapNavigation: {
    enabled: true,
    buttonOptions: {
      verticalAlign: "bottom",
    },
  },

  plotOptions: {
    map: {
      states: {
        hover: {
          color: "#EEDD66",
        },
      },
    },
  },

  series: [
    {
      data: data,
      name: "India",
      dataLabels: {
        enabled: false,
        format: "5",
      },
    },
    {
      type: "mapline",
      data: separators,
      color: "silver",
      enableMouseTracking: false,
      animation: {
        duration: 500,
      },
    },
  ],

  drilldown: {
    activeDataLabelStyle: {
      color: "#FFFFFF",
      textDecoration: "none",
      textOutline: "1px #000000",
    },
    drillUpButton: {
      relativeTo: "spacingBox",
      position: {
        x: 0,
        y: 60,
      },
    },
  },
};
function Demo({ stateData: SData }) {
  // console.log("SData", SData);
  useEffect(() => {
    data.forEach((el, i) => {
      const matched = SData.filter((e) => e.HCA2 === el.properties["hc-a2"]);
      let totalAmmount = 0;
      if (matched.length > 0) {
        matched.forEach((element) => {
          totalAmmount += element.Total_Transaction;
        });
      }
      console.log(`totalAmount of   ${el.properties["hc-a2"]} is ${totalAmmount}`);

      el.drilldown = el.properties["hc-a2"];
      el.value = totalAmmount;
    });
  }, [SData]);

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        constructorType={"mapChart"}
      />
    </div>
  );
}

export default Demo;
